// components/auth/UserAvatar.tsx
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const UserAvatar = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const getUserInitials = () => {
    if (!user?.name) return 'U';
    const names = user.name.split(' ');
    if (names.length >= 2) {
      return `${names[0][0]}${names[1][0]}`.toUpperCase();
    }
    return user.name.substring(0, 2).toUpperCase();
  };

  return (
    <Avatar className="h-10 w-10">
      {/* <AvatarImage src={user?.avatar_url} alt={user?.name || 'User'} /> */}
      <AvatarFallback className="bg-gradient-to-br from-theme-primary to-theme-accent text-white">
        {getUserInitials()}
      </AvatarFallback>
    </Avatar>
  );
};
